import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Contador } from '../../components/turns/Contador';
import { AlertContext } from '../../contexts/AlertContext';
import { LoaderContext } from '../../contexts/LoaderContext';
import { SocketContext } from '../../contexts/SocketContext';
import { convertirLetraMayus } from '../../helpers/convertirLetraMayus';
import { formatearFecha } from '../../helpers/fechaHoras';
import { Estado } from '../../components/turns/Estado';
import dayjs from 'dayjs';

const columns = [
    { id: "turno", label: "Turno", minWidth: 170, align: 'center' },
    { id: "transaccion", label: "Transacción", minWidth: 100, align: 'center' },
    { id: "creado", label: "Fecha", minWidth: 170, align: 'center' },
    { id: "atencion", label: "Atención", minWidth: 170, align: 'center' },
    { id: "modulo", label: "Módulo", minWidth: 170, align: 'center' },
    { id: "cajero", label: "Cajero", minWidth: 170, align: 'center' },
];

export const useTramitTurns = (sede) => {

    const [total, setTotal] = useState(0);
    const [turnos, setTurnos] = useState([]);

    const { setOpenLoader } = useContext(LoaderContext);
    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);

    useLayoutEffect(() => {
        let unsubscribed = true;
        unsubscribed && obtenerTurnosPorSede();

        return () => { 
            unsubscribed = false;
            socket.off('frontend:obtener-turnos');
        }
    }, [sede]);

    useEffect(() => {
        let unsubscribed = true;
        unsubscribed && refrescarTurnos();

        return () => { 
            unsubscribed = false;
            socket.off('backend:refrescar-turnos');
        }
    }, []);

    const obtenerTurnosPorSede = () => {
        setOpenLoader(true);
        socket.emit('frontend:obtener-turnos', { sede, estado: 2 }, response => {
            const { ok, message, total, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current.handleOpen('error', message);
                return;
            }

            setTotal(total);
            setTurnos(data.map(turno => construirPayload(turno)));
            setOpenLoader(false);
        });
    }

    const refrescarTurnos = () => socket.on('backend:refrescar-turnos', (response) => {
        const { ok, message, total, data } = response;

        if(!ok) {
            setOpenLoader(false);
            alertRef.current.handleOpen('error', message);
            return;
        }

        if(data?.sede?._id !== sede) return;

        if(data?.estado === 2) {
            setTotal(e => e + total);
            agregarTurnoAlArreglo(data);
            return;
        }

        if(data?.estado === 3) return actualizarTurnoDelArreglo(data);

        if(data?.estado === 4) {
            setTotal(e => e - 1);
            eliminarTurnoDelArreglo(data);
            return;
        }
    });

    const agregarTurnoAlArreglo = (turno) => {
        setTurnos(prev => ([ ...prev, construirPayload(turno) ]));
    }

    const actualizarTurnoDelArreglo = (turno) => {
        setTurnos(prev => prev?.map(t => t?.uid === turno?.uid ? construirPayload(turno) : t));
    }

    const eliminarTurnoDelArreglo = (turno) => {
        setTurnos(prev => prev?.filter(t => t?.uid !== turno?.uid));
    }

    const construirPayload = (turno) => ({
        ...turno,
        turno: turno?.turno.toUpperCase(),
        transaccion: convertirLetraMayus(turno?.tramite?.nombre),
        creado: (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>{ formatearFecha(turno?.creado) }</span>
                <span style={{ fontSize: 12, fontWeight: 600 }}>{ dayjs(turno?.creado).format('hh:mm:ss A') }</span>
            </div>
        ),
        atencion: (
            <Estado estado={ turno?.estado } fecha={ turno?.actualizado } tiempo={ turno?.tramite?.tiempo_maximo_atencion } data={ turno }>
                <Contador fecha={ turno?.actualizado } estado={ turno?.estado } style={{ color: '#fff', fontWeight: 'bold', textAlign: 'center' }} />
            </Estado>
        ),
        modulo: convertirLetraMayus(turno?.modulo_nombre),
        cajero: !turno?.cajero ? 'Esperando...' : convertirLetraMayus(turno?.cajero?.nombre, true)
    });
    
    return {
        columns,
        total,
        turnos
    }
}